export default __webpack_public_path__ + "static/media/mi-perfil-img.5a515af8.png";